import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from 'environments/environment';
import { Tags } from '@repositories/models';
import { Column, DataTableInput, DataTableOutput, Order, PagedData, Search } from '@core/models/datables';

@Injectable({ providedIn: 'root' })
export class TagsService { 

constructor(private _http: HttpClient){}

private columns: Column[] = [
  {
    data: "id",
    name: "ID",
    searchable: true,
    orderable: true,
    search: new Search()
  },
  {
    data: "name",
    name: "Name",
    searchable: true,
    orderable: true,
    search: new Search()
  },
  {
    data: "created_at",
    name: "Date",
    searchable: true,
    orderable: true,
    search: new Search()
  }
]

/**
 * Get tag by id
 */

getById(id:number){
    return this._http.get<Tags>(`${environment.repositoriesApiUrl}/api/tags/${id}`);
}

/**
 * Search tags by name
 */
 queryByName(name:string){
  return this._http.get<Tags[]>(`${environment.repositoriesApiUrl}/api/tags/query/${name}`);
}

/**
 * Get All Tags
 * @returns 
 */
getAll(page: number, quantity:number){
    return this._http.get<PagedData<Tags>>(`${environment.repositoriesApiUrl}/api/tags/page/${page}/${quantity}`);
}

getAllTags(page: number, quantity: number, order: Order, searchText: string){
  const input = this.createDataTableInput(page, quantity, order, searchText);
  return this._http.post<DataTableOutput<Tags>>(`${environment.repositoriesApiUrl}/api/tags/index`, input);
}

addTag(tags){
    return this._http.post<Tags>(`${environment.repositoriesApiUrl}/api/tags`, tags).pipe(
        map((response: any) => response.tags as Tags),
        catchError(e => {
          return throwError(e);
        })
      );
}

editTag(tags){
    return this._http.put<Tags>(`${environment.repositoriesApiUrl}/api/tags/${tags.id}`, tags).pipe(
      map((response: any) => response.tags as Tags),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  deleteTag(tag){
    return this._http.delete<Tags>(`${environment.repositoriesApiUrl}/api/tags/${tag}`).pipe(
      map((response: any) => response.tags as Tags),
      catchError(e => {
        return throwError(e);
      })
    );
  }
  private createDataTableInput(page: number, quantity: number, order: Order, searchText: string): DataTableInput{
    let input = new DataTableInput();
    input.start = page * quantity;
    input.length = quantity;
    if (searchText !== ''){
      input.search.regex = true;
      input.search.value = searchText;
    }
    if(order){
      input.order.push(order);
    }
    input.columns = this.columns;
    return input;
  }
  
}
